module.exports = __webpack_public_path__ + "media/20190918174606810.78ab1f8c.mp4";